<template>
  <div>
    <div class="m-toast" v-show="visible">
      <p><img class="icon" :src="iconSrc"/>{{htmlString}}</p>
    </div>
  </div>
</template>
<script lang="ts">
  import {
    defineComponent,
    ref,
    computed
  } from "vue";
  export default defineComponent({
    setup() {
      const htmlString = ref<string>();
      const visible = ref<boolean>(false);
      const timer = ref<number>(0);
      const icontype =  ref<string>();
      const show: (html: any, icon: any) => void = (html: any, icon: any) => {
        icontype.value = icon || "1"
        htmlString.value = html;
        visible.value = true;
        window.clearTimeout(parseInt(timer.value.toString()));
        timer.value = window.setTimeout(() => {
          setTimeout(() => {
            visible.value = false;
          }, 500);
        }, 1500);
      }
      const iconSrc = computed(() => {
        let temp = ""
        if(icontype.value === "1"){
          temp = "https://static.soyoung.com/sy-pre/error-1609135800751.png"
        } else if(icontype.value === "2"){
          temp = "https://static.soyoung.com/sy-pre/success-1609135800751.png"
        } else if(icontype.value === "3"){
          temp = "https://static.soyoung.com/sy-pre/warning%20-1609135800751.png"
        }
        return temp
      });
      return {
        show,
        htmlString,
        visible,
        iconSrc
      }
    }
  })
</script>
<style lang="less" scoped>
.m-toast {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    left: 0;
    top: 10%;
    z-index: 99999;
    transition: opacity 0.5s;
    opacity: 4;
    &.opacity {
      opacity: 1;
    }
    p {
      position: relative;
      justify-content: center;
      align-items: center;
      background: #FFFFFF;
      display: flex;
      box-shadow: 0 4px 12px 0 rgba(0,0,0,0.15);
      border-radius: 4px;
      padding: 10px 18px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      line-height: 20px;
      .icon{
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
    }
  }
</style>

